<app-multi-selection-list-modal
  [id]="'select-users-dialog'"
  [title]="translations.title"
  [searchPlaceholder]="translations.searchPlaceholder"
  [sections]="{ contentHeader, columns }"
  [fetchConfig]="{ fetch }"
  [filters]="filters"
  [emptyMessage]="translations.emptyMessage"
  (confirm)="submitAndClose($event)"
  (cancel)="cancel($event)"
>
  <ng-template #contentHeader>{{ data.contentHeader || translations.contentHeader }}</ng-template>

  <ng-template #userHeader>{{ 'Name' | translate }}</ng-template>
  <ng-template #userCell let-user>
    <app-lightweight-user-avatar
      width="32"
      [showName]="true"
      [isUser]="!!user"
      [profileImage]="user?.profile_image"
      [userRole]="user?.role"
      [userEmail]="user?.email"
      [userName]="user?.name"
    ></app-lightweight-user-avatar>
  </ng-template>
</app-multi-selection-list-modal>
